var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.28340",
      "conversations-internal-schema": "static-1.13450",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8376",
      "hubspot-url-utils": "static-1.4374",
      "HubStyleTokens": "static-2.11834",
      "I18n": "static-7.1679",
      "jasmine-runner": "static-1.6791",
      "quartz": "static-1.7508",
      "react": "static-7.198",
      "reselect": "static-3.12",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.507",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6492",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "moment": "static-3.75",
      "customer-data-email": "static-1.18572",
      "cv-backend-services": "static-1.1597",
      "hub-http": "static-1.6553",
      "immutable": "static-2.87",
      "immutable-less": "static-1.4992",
      "quartz-config": "static-1.1286",
      "quartz-core": "static-1.6727",
      "transmute": "static-2.97",
      "HeadJS": "static-2.803",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8551",
      "framer-motion": "static-1.79",
      "hs-test-utils-bend-plugin": "static-1.3487",
      "msw": "static-1.39",
      "react-redux": "static-7.79",
      "redux": "static-4.80",
      "testing-library": "static-1.158",
      "foundations-theming": "static-1.4817",
      "i18n-data": "static-1.230",
      "metrics-js": "static-1.9977",
      "moment-timezone": "static-5.91",
      "react-utils": "static-2.5582",
      "jasmine": "static-4.4653",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3233",
      "react-aria": "static-1.72",
      "styled-components": "static-2.99",
      "UIComponents": "static-3.8780",
      "visitor-ui-component-library-icons": "static-1.6303",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.4998",
      "apollo-stack-hubspot": "static-3.94",
      "classnames": "static-2.10",
      "cssUtils": "static-1.963",
      "customer-data-objects": "static-1.8038",
      "customer-data-ui-utilities": "static-1.10172",
      "data-fetching-client": "static-1.9994",
      "FileManagerCore": "static-1.40088",
      "FileManagerLib": "static-1.40229",
      "foundations-assets": "static-1.5228",
      "graphql": "static-1.89",
      "hs-promise-utils": "static-1.5931",
      "hubspot-apollo-client": "static-1.5218",
      "icons": "static-2.694",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.113",
      "react-virtualized": "static-2.107",
      "rpc-client-utils": "static-1.5007",
      "salesImages": "static-1.601",
      "timezone-utils": "static-2.5584",
      "ui-gdpr-components": "static-1.10637",
      "ts-schema": "static-1.4320",
      "hs-locale-management": "static-1.321",
      "hs-lodash": "static-4.45",
      "immer": "static-1.101",
      "opentelemetry-fe-types": "static-1.117",
      "dispatcher": "static-1.143",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.887",
      "hubspotter-http": "static-1.4890",
      "mobile-manifest-mixins": "static-1.583",
      "module-federation": "static-1.33",
      "opentelemetry-fe": "static-1.492",
      "quartz-auth": "static-1.1183",
      "quartz-head": "static-1.1173",
      "quartz-i18n": "static-1.1183",
      "quartz-routing": "static-1.938",
      "quartz-test": "static-1.1183",
      "quartz-tracking": "static-1.887",
      "quick-fetch": "static-1.4154",
      "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
      "trellis-components": "static-1.2760",
      "ui-fonts": "static-1.1096",
      "usage-tracker-container": "static-1.7644",
      "usage-tracker-core": "static-1.7504",
      "bend-plugin-foundations-components": "static-1.4820",
      "floating-ui": "static-1.63",
      "foundations-theming-specialty": "static-1.2533",
      "hs-story-utils": "static-1.9766",
      "react-create-root-preference": "static-1.78",
      "tanstack-table": "static-1.61",
      "trellis-assets": "static-1.2741",
      "ui-images": "static-2.1263",
      "bender-build-tools": "static-1.3452",
      "bend-plugin-foundations-theming": "static-1.3300",
      "foundations-theming-base": "static-1.3802",
      "stylex": "static-1.41",
      "HubStyle": "static-2.12141",
      "web-vitals": "static-1.15",
      "sassPrefix": "static-1.230",
      "inbound-db-properties-service-client": "static-1.4074",
      "property-translator": "static-1.5734",
      "react-dnd-compat": "static-1.4957",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9797",
      "breeze-artifacts-sdk": "static-1.464",
      "copilot-toolkit": "static-1.11913",
      "audio-components": "static-1.6396",
      "ContentUtils": "static-1.69203",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29862",
      "file-manager-components": "static-1.24589",
      "FileManagerImages": "static-1.37740",
      "foundations-components-legacy": "static-1.1576",
      "html-to-image": "static-1.61",
      "immerable": "static-1.4487",
      "react-colorpicker": "static-2.10554",
      "redux-toolkit": "static-1.78",
      "ui-universal-auth": "static-1.9473",
      "urlinator": "static-1.4871",
      "usage-tracker": "static-1.7654",
      "video-components": "static-1.14218",
      "video-data-lib": "static-1.35874",
      "video-embed": "static-1.36708",
      "redux-thunk": "static-2.80",
      "hubspot-apollo-cache": "static-1.677",
      "bend-plugin-chirp-manifest": "static-1.417",
      "chirp-fetch": "static-1.2237",
      "opentelemetry-web": "static-1.15",
      "beacon-keepalive-queue": "static-1.45",
      "hub-http-shared-msw-handlers": "static-1.10683",
      "hubspotter-http-shared-msw-handlers": "static-1.10681",
      "usage-tracker-session-replay": "static-1.5340",
      "base-ui": "static-1.22",
      "react-day-picker": "static-1.10",
      "trellis-theming": "static-1.1315",
      "tanstack-virtual": "static-1.38",
      "stylex-utils": "static-1.147",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.23193",
      "customer-data-objects-ui-components": "static-1.13372",
      "sanitize": "static-1.4813",
      "sanitize-text": "static-1.8498",
      "breeze-engine-lib": "static-1.1838",
      "magpie-lib": "static-1.5785",
      "magpie-types": "static-1.5245",
      "simple-logging-lib": "static-1.3392",
      "superstore": "static-1.5100",
      "content-assistance-lib": "static-1.8249",
      "cms-field-types": "static-1.5153",
      "content-icons-ui": "static-1.2404",
      "integrations-lib": "static-1.17144",
      "underscore": "static-1.8",
      "ui-addon-iframeable": "static-1.9418",
      "video-components-external": "static-1.12216",
      "unified-auth-core-lib": "static-1.1269",
      "social-insights-client-types": "static-1.22706",
      "SharedI18nStrings": "static-1.183",
      "outpost": "static-1.4493",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "atom": "static-1.5423",
      "avatar-components": "static-1.2823",
      "reference-resolvers": "static-1.8522",
      "breeze-engine-chat-components": "static-1.816",
      "breeze-engine-core": "static-1.1116",
      "ably": "static-2.2",
      "highlight.js": "static-1.86",
      "batch-promise": "static-1.1886",
      "pulse": "static-1.971",
      "idb-keyval": "static-1.51",
      "reactive-lib": "static-1.1060",
      "ui-addon-video-player": "static-1.9043",
      "ui-coaching-tips": "static-1.29378",
      "flux-actions": "static-1.373",
      "frontend-preferences-client": "static-1.8260",
      "integrations-error-boundary-lib": "static-1.14559",
      "integrations-tracking-lib": "static-1.5949",
      "laboratory-lib": "static-3.7494",
      "native-integrations-shared-strings": "static-1.8118",
      "redux-observable": "static-1.75",
      "ReduxMessenger": "static-2.10711",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11487",
      "ui-shepherd-react": "static-3.10611",
      "unified-auth": "static-1.987",
      "navigation-messaging": "static-1.8233",
      "content-media-composition-data-lib": "static-1.13326",
      "content-media-compositions": "static-2.17333",
      "media-bridge-lib": "static-1.19456",
      "fsm": "static-1.4094",
      "bend-plugin-pulse": "static-1.474",
      "event-emitter": "static-1.1296",
      "fast-json-patch": "static-1.70",
      "react-dlb": "static-1.89",
      "growth-onboarding-feedback-components": "static-1.6926",
      "universal-page-editor-lib": "static-1.3349",
      "foundations-components-test-utils": "static-1.6034",
      "adobe-sign-auth-lib": "static-1.537",
      "ads-unified-auth-lib": "static-1.1506",
      "custom-vendor-connection-lib": "static-1.37",
      "google-sheets-integration-lib": "static-1.1100",
      "microsoft-drive-auth-lib": "static-1.218",
      "surveymonkey-integration-lib": "static-1.557",
      "slack-ui-library": "static-1.10740",
      "js-cookie": "static-1.18",
      "crm-record-cards-service-types": "static-1.3796",
      "framework-data-schema-resolvers": "static-1.7234",
      "location-customization-utils-lib": "static-1.10175",
      "conditional-properties-service-client": "static-1.4043",
      "crm-pipelines-api-client-types": "static-1.4374",
      "fdsr-migration-layer": "static-1.353",
      "framework-builder-read-service-client": "static-1.4248",
      "framework-data-schema-quick-fetch": "static-1.7139",
      "inbound-db-meta-service-client": "static-1.3718",
      "multi-currency-client-types": "static-1.3934",
      "persist-promise": "static-1.4043"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.28340",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13450",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8376",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4374",
      "HubStyleTokens": "/HubStyleTokens/static-2.11834",
      "I18n": "/I18n/static-7.1679",
      "jasmine-runner": "/jasmine-runner/static-1.6791",
      "quartz": "/quartz/static-1.7508",
      "react": "/react/static-7.198",
      "reselect": "/reselect/static-3.12",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.507",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6492",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "moment": "/moment/static-3.75",
      "customer-data-email": "/customer-data-email/static-1.18572",
      "cv-backend-services": "/cv-backend-services/static-1.1597",
      "hub-http": "/hub-http/static-1.6553",
      "immutable": "/immutable/static-2.87",
      "immutable-less": "/immutable-less/static-1.4992",
      "quartz-config": "/quartz-config/static-1.1286",
      "quartz-core": "/quartz-core/static-1.6727",
      "transmute": "/transmute/static-2.97",
      "HeadJS": "/HeadJS/static-2.803",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8551",
      "framer-motion": "/framer-motion/static-1.79",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3487",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.79",
      "redux": "/redux/static-4.80",
      "testing-library": "/testing-library/static-1.158",
      "foundations-theming": "/foundations-theming/static-1.4817",
      "i18n-data": "/i18n-data/static-1.230",
      "metrics-js": "/metrics-js/static-1.9977",
      "moment-timezone": "/moment-timezone/static-5.91",
      "react-utils": "/react-utils/static-2.5582",
      "jasmine": "/jasmine/static-4.4653",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3233",
      "react-aria": "/react-aria/static-1.72",
      "styled-components": "/styled-components/static-2.99",
      "UIComponents": "/UIComponents/static-3.8780",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6303",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4998",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.963",
      "customer-data-objects": "/customer-data-objects/static-1.8038",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10172",
      "data-fetching-client": "/data-fetching-client/static-1.9994",
      "FileManagerCore": "/FileManagerCore/static-1.40088",
      "FileManagerLib": "/FileManagerLib/static-1.40229",
      "foundations-assets": "/foundations-assets/static-1.5228",
      "graphql": "/graphql/static-1.89",
      "hs-promise-utils": "/hs-promise-utils/static-1.5931",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5218",
      "icons": "/icons/static-2.694",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.113",
      "react-virtualized": "/react-virtualized/static-2.107",
      "rpc-client-utils": "/rpc-client-utils/static-1.5007",
      "salesImages": "/salesImages/static-1.601",
      "timezone-utils": "/timezone-utils/static-2.5584",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10637",
      "ts-schema": "/ts-schema/static-1.4320",
      "hs-locale-management": "/hs-locale-management/static-1.321",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.101",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.117",
      "dispatcher": "/dispatcher/static-1.143",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.887",
      "hubspotter-http": "/hubspotter-http/static-1.4890",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
      "module-federation": "/module-federation/static-1.33",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.492",
      "quartz-auth": "/quartz-auth/static-1.1183",
      "quartz-head": "/quartz-head/static-1.1173",
      "quartz-i18n": "/quartz-i18n/static-1.1183",
      "quartz-routing": "/quartz-routing/static-1.938",
      "quartz-test": "/quartz-test/static-1.1183",
      "quartz-tracking": "/quartz-tracking/static-1.887",
      "quick-fetch": "/quick-fetch/static-1.4154",
      "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
      "trellis-components": "/trellis-components/static-1.2760",
      "ui-fonts": "/ui-fonts/static-1.1096",
      "usage-tracker-container": "/usage-tracker-container/static-1.7644",
      "usage-tracker-core": "/usage-tracker-core/static-1.7504",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4820",
      "floating-ui": "/floating-ui/static-1.63",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2533",
      "hs-story-utils": "/hs-story-utils/static-1.9766",
      "react-create-root-preference": "/react-create-root-preference/static-1.78",
      "tanstack-table": "/tanstack-table/static-1.61",
      "trellis-assets": "/trellis-assets/static-1.2741",
      "ui-images": "/ui-images/static-2.1263",
      "bender-build-tools": "/bender-build-tools/static-1.3452",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3300",
      "foundations-theming-base": "/foundations-theming-base/static-1.3802",
      "stylex": "/stylex/static-1.41",
      "HubStyle": "/HubStyle/static-2.12141",
      "web-vitals": "/web-vitals/static-1.15",
      "sassPrefix": "/sassPrefix/static-1.230",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4074",
      "property-translator": "/property-translator/static-1.5734",
      "react-dnd-compat": "/react-dnd-compat/static-1.4957",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9797",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.464",
      "copilot-toolkit": "/copilot-toolkit/static-1.11913",
      "audio-components": "/audio-components/static-1.6396",
      "ContentUtils": "/ContentUtils/static-1.69203",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29862",
      "file-manager-components": "/file-manager-components/static-1.24589",
      "FileManagerImages": "/FileManagerImages/static-1.37740",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1576",
      "html-to-image": "/html-to-image/static-1.61",
      "immerable": "/immerable/static-1.4487",
      "react-colorpicker": "/react-colorpicker/static-2.10554",
      "redux-toolkit": "/redux-toolkit/static-1.78",
      "ui-universal-auth": "/ui-universal-auth/static-1.9473",
      "urlinator": "/urlinator/static-1.4871",
      "usage-tracker": "/usage-tracker/static-1.7654",
      "video-components": "/video-components/static-1.14218",
      "video-data-lib": "/video-data-lib/static-1.35874",
      "video-embed": "/video-embed/static-1.36708",
      "redux-thunk": "/redux-thunk/static-2.80",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.677",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.417",
      "chirp-fetch": "/chirp-fetch/static-1.2237",
      "opentelemetry-web": "/opentelemetry-web/static-1.15",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.45",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10683",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10681",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5340",
      "base-ui": "/base-ui/static-1.22",
      "react-day-picker": "/react-day-picker/static-1.10",
      "trellis-theming": "/trellis-theming/static-1.1315",
      "tanstack-virtual": "/tanstack-virtual/static-1.38",
      "stylex-utils": "/stylex-utils/static-1.147",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.23193",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13372",
      "sanitize": "/sanitize/static-1.4813",
      "sanitize-text": "/sanitize-text/static-1.8498",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1838",
      "magpie-lib": "/magpie-lib/static-1.5785",
      "magpie-types": "/magpie-types/static-1.5245",
      "simple-logging-lib": "/simple-logging-lib/static-1.3392",
      "superstore": "/superstore/static-1.5100",
      "content-assistance-lib": "/content-assistance-lib/static-1.8249",
      "cms-field-types": "/cms-field-types/static-1.5153",
      "content-icons-ui": "/content-icons-ui/static-1.2404",
      "integrations-lib": "/integrations-lib/static-1.17144",
      "underscore": "/underscore/static-1.8",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9418",
      "video-components-external": "/video-components-external/static-1.12216",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1269",
      "social-insights-client-types": "/social-insights-client-types/static-1.22706",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
      "outpost": "/outpost/static-1.4493",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "atom": "/atom/static-1.5423",
      "avatar-components": "/avatar-components/static-1.2823",
      "reference-resolvers": "/reference-resolvers/static-1.8522",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.816",
      "breeze-engine-core": "/breeze-engine-core/static-1.1116",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.86",
      "batch-promise": "/batch-promise/static-1.1886",
      "pulse": "/pulse/static-1.971",
      "idb-keyval": "/idb-keyval/static-1.51",
      "reactive-lib": "/reactive-lib/static-1.1060",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9043",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29378",
      "flux-actions": "/flux-actions/static-1.373",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8260",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14559",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5949",
      "laboratory-lib": "/laboratory-lib/static-3.7494",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8118",
      "redux-observable": "/redux-observable/static-1.75",
      "ReduxMessenger": "/ReduxMessenger/static-2.10711",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11487",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10611",
      "unified-auth": "/unified-auth/static-1.987",
      "navigation-messaging": "/navigation-messaging/static-1.8233",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13326",
      "content-media-compositions": "/content-media-compositions/static-2.17333",
      "media-bridge-lib": "/media-bridge-lib/static-1.19456",
      "fsm": "/fsm/static-1.4094",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.474",
      "event-emitter": "/event-emitter/static-1.1296",
      "fast-json-patch": "/fast-json-patch/static-1.70",
      "react-dlb": "/react-dlb/static-1.89",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6926",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3349",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6034",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.537",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1506",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.37",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1100",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.218",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.557",
      "slack-ui-library": "/slack-ui-library/static-1.10740",
      "js-cookie": "/js-cookie/static-1.18",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7234",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10175",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4043",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4374",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.353",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4248",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7139",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3934",
      "persist-promise": "/persist-promise/static-1.4043"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.28340",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};